import React from 'react';

class BatchUploadIcon extends React.Component {

  render() {
    return (
      <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="18"
      x="0"
      y="0"
      version="1.1"
      viewBox="0 0 58 58"
    >
      <g transform="translate(-3 -3)">
        <path d="M46 31c-.34 0-.67 0-1 .05V16.83a3 3 0 00-.88-2.12L33.29 3.88A3 3 0 0031.17 3H6a3 3 0 00-3 3v46a3 3 0 003 3h28a15 15 0 1012-24zm-4.41-16H34a1 1 0 01-1-1V6.41zM6 53a1 1 0 01-1-1V6a1 1 0 011-1h25v9a3 3 0 003 3h9v14.3A15 15 0 0031 46a14.87 14.87 0 001.74 7zm40 6a13 13 0 1113-13 13 13 0 01-13 13z"></path>
        <path d="M46.71 37.29a1 1 0 00-1.42 0l-6 6a1.004 1.004 0 001.42 1.42l4.29-4.3V54a1 1 0 002 0V40.41l4.29 4.3a1 1 0 001.42 0 1 1 0 000-1.42z"></path>
      </g>
    </svg>
    )
  }
}

export default BatchUploadIcon;
